import type { FC } from 'react';
import { Box, CircularProgress, IconButton } from '@mui/material';
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import FullscreenExitIcon from '@mui/icons-material/FullscreenExit';
import '../theme/partials/TableHeader.css';
import ColumnSelector from 'src/components/grid/ColumnSelector';
import { gridColumnProperties } from 'src/types/gridColumnProperties';

interface Props {
  title?: string;
  hasToggleFullScreen?: boolean;
  isFullScreen?: boolean;
  hasProgress?: boolean;
  columns?: gridColumnProperties[];
  onToggleFullScreen?: () => void;
  onColumnsSelect?: (field: string) => void;
  className?: string;
  children?: React.ReactNode;
  endContent?: React.ReactNode;
  hideColumnSelector?: boolean;
}

const TableHeader: FC<React.PropsWithChildren<Props>> = ({
  title,
  children,
  hasProgress,
  columns,
  onColumnsSelect,
  className,
  endContent,
  hasToggleFullScreen,
  isFullScreen,
  onToggleFullScreen,
  hideColumnSelector = false,
}) => {
  const toggleColumn = (field: string) => {
    onColumnsSelect(field);
  };

  return (
    <div className="table-header">
      <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
        <div className={`w-100 d-flex align-items-center table-header-content-group ${className}`}>
          {title ? <Box sx={{ pr: 4 }}>{title}</Box> : <></>}
          {children}
        </div>
        <Box sx={{ flex: '1 auto', textAlign: 'right', alignItems: 'center', justifyContent: 'flex-end', display: 'flex' }} className="table-header-content-group__expander">
          {hasProgress && <CircularProgress className="d-none d-md-block" size="20px" sx={{ mr: '5px' }} />}

          {endContent && <Box className="table-header__end-content">{endContent}</Box>}

          {!hideColumnSelector && columns && (
            <Box className="table-header__column-selector">
              <ColumnSelector
                columns={columns}
                onChange={(field: string) => {
                  toggleColumn(field);
                }}
              ></ColumnSelector>
            </Box>
          )}

          {hasToggleFullScreen && (
            <IconButton size="small" onClick={onToggleFullScreen}>
              {isFullScreen && <FullscreenExitIcon />}
              {!isFullScreen && <FullscreenIcon />}
            </IconButton>
          )}
        </Box>
      </Box>
    </div>
  );
};

export default TableHeader;
